import React from 'react';
import _ from 'lodash';

import { useRegisterActivityQuery } from 'generated/graphql';
import { authService } from 'iron-forge-react-modules';



export interface IInvite {
  id: string;
  isClaimed: boolean;
}

export interface IData {
  invite: IInvite | null;
}

export function useQuery(inviteCode: string) {
  const tuple = useRegisterActivityQuery({
    variables: {
      code: inviteCode
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        invite: tuple.data?.invite ? {
          id: tuple.data.invite.id,
          isClaimed: tuple.data.invite.isClaimed
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useRegister(inviteCode: string) {
  const [authServiceIsLoading, setAuthServiceIsLoading] = React.useState(false);

  async function fnRegister({
    email, phoneNumber, password
  }: {
    email: string;
    phoneNumber: string;
    password: string;
  }) {
    try {
      setAuthServiceIsLoading(true);
      await authService.register({
        email,
        phoneNumber,
        password
      });
      await __registerUser(email, inviteCode);

    } finally {
      setAuthServiceIsLoading(false);
    }
  }

  return [
    fnRegister,
    {
      isLoading: authServiceIsLoading
    }
  ] as const;
}



async function __registerUser(email: string, inviteCode: string) {
  const result = await fetch(process.env.REACT_APP_API_GRAPHQL_URL ?? '', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: `
        mutation RegisterUser($input: RegisterUserInput!) {
          registerUser(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: {
          email,
          inviteCode
        }
      }
    })
  });

  const body = await result.json();
  return !_.isNil(body.data.registerUser);

}
